import * as VueRouter from 'vue-router'
import Blog from './Blog.vue'
import Board from './Board.vue'
import Clip from './Clip.vue'
import Landing from './Landing.vue'
import Login from './Login.vue'
import PasswordReset from './PasswordReset.vue'
import EmailConfirmation from './EmailConfirmation.vue'

let router = VueRouter.createRouter({
  history:VueRouter.createWebHistory(),
  routes: [
    {path: '/', component: Landing, meta: {auth: false}},
    {path: '/boards', component: Board, meta: {auth: true}},
    {path: '/login', component: Login, meta: {auth: true}},
    {path: '/password_reset', component: PasswordReset, meta: {auth: false}},
    {path: '/email_confirmation', component: EmailConfirmation, meta: {auth: false}},
    {path: '/clips/:token?', component: Clip, meta: {auth: false}},
    {path: '/blog/:slug?', component: Blog, meta: {auth: false}},
    {path: '/:other(.*)*', redirect: "/boards"},
  ],
  scrollBehavior(to, from, savedPosition) {
    return {top: 0}
  }
})

export default router